var SpNav = (function () {
    function SpNav() {
        this.menuBtn = document.getElementById('menu_btn');
        this.menuClose = document.querySelector('.menu_close');
        this.nav = document.querySelector('header nav');
    }
    SpNav.prototype.menuToggle = function () {
        var _a, _b, _c, _d, _e;
        if ((_a = this.menuBtn) === null || _a === void 0 ? void 0 : _a.classList.contains('active')) {
            (_b = this.menuBtn) === null || _b === void 0 ? void 0 : _b.classList.remove('active');
            (_c = this.nav) === null || _c === void 0 ? void 0 : _c.classList.remove('is-open');
        }
        else {
            (_d = this.menuBtn) === null || _d === void 0 ? void 0 : _d.classList.add('active');
            (_e = this.nav) === null || _e === void 0 ? void 0 : _e.classList.add('is-open');
        }
    };
    SpNav.prototype.execute = function () {
        var _this = this;
        var _a, _b;
        (_a = this.menuBtn) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            _this.menuToggle();
        });
        (_b = this.menuClose) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
            _this.menuToggle();
        });
    };
    return SpNav;
}());
export default SpNav;
